import {getFileNameAndExtension} from '@ey/utils';
import * as actions from '../../actions/actiontypes';
import Utility from '../../util/utilityfunctions';
import {QuickFilterTypes} from '../../util/uiconstants';
import initialstate from '../initialstate';

export default function piceqrDocumentListReducer(state = initialstate.piceqrDocumentListFilters, action) {
	switch (action.type) {
		case actions.SET_PIC_EQR_DOCUMENT_LIST_FILTERS: {
			let _state = {...state};
			let filters = {..._state.filters};
			let parentfilters = {..._state[action.parentName]?.filters};
			parentfilters = action.resetpagination
				? {...parentfilters, specific: {...parentfilters.specific, page: 1, pageSize:20}}
				: {...parentfilters, specific: {...parentfilters.specific, page: 1}};

			if (action.filterKey) {
				if (action.resetfilters) {
					_state.filters = {
						[action.filterKey]: action.filters
					};
				} else {
					_state.filters = {
						[action.filterKey]: filters[action.filterKey]
							? {...filters[action.filterKey], ...action.filters}
							: action.filters
					};
				}
			}

			return {
				..._state,
				[action.parentName]: {
					filters: parentfilters,
					response: {
						refresh: true
					},
					upload: state[action.parentName]?.upload
				}
			};
		}

		case actions.SET_PIC_EQR_DOCUMENT_LIST_FILTER: {
			let value = action.value;
			if (!Utility.hasValue(value)) {
				// If filter is being disabled, explicit undefined is required
				value = null;
			}
			let _state = {...state};
			let filters = {..._state.filters};
			let parentfilters = {..._state[action.parentName]?.filters};
			if (action.filterKey) {
				if (filters[action.filterKey]) {
					filters[action.filterKey] = {...filters[action.filterKey]};
				} else {
					filters[action.filterKey] = {};
				}
				if (value === null) {
					delete filters[action.filterKey][action.filterItemName];
				} else {
					filters[action.filterKey][action.filterItemName] = value;
				}
			} else {
				filters[action.filterItemName] = value;
			}

			// Page number must be rest to zero to all active instances
			let result = {...state};

			Object.entries(result).forEach((item) => {
				if (item[0] !== 'filters' && item[1]?.response) {
					if (action.filterKey === item[1]?.filterKey) {
						let filters = {...state[item[0]].filters};
						if (!filters.specific) {
							filters.specific = {page: 1};
						} else {
							filters.specific = {...filters.specific, page: 1};
						}

						result[item[0]] = {
							filters,
							response: {
								refresh: true
							}
						};
					}
				}
			});

			return {
				...result,
				filters,
				[action.parentName]: {
					...state[action.parentName],
					response: {refresh: true},
					filters: {...parentfilters, specific: {...parentfilters.specific, page: 1}}
				}
			};
		}

		case actions.SYNC_PIC_EQR_DOCUMENT_LIST_TILE: {
			let value = action.value;
			if (!Utility.hasValue(value)) {
				// If filter is being disabled, explicit undefined is required
				value = null;
			}
			let _state = {...state};
			let filters = {..._state.filters};
			let parentfilters = {..._state[action.parentName]?.filters};
			if (action.filterKey) {
				if (filters[action.filterKey]) {
					filters[action.filterKey] = {...filters[action.filterKey]};
					delete filters[action.filterKey][action.filterToBeRemoved];
				} else {
					filters[action.filterKey] = {};
				}

				filters[action.filterKey][action.filterItemName] = value;
			} else {
				filters[action.filterItemName] = value;
			}

			// Page number must be rest to zero to all active instances
			let result = {...state};

			Object.entries(result).forEach((item) => {
				if (item[0] !== 'filters' && item[1]?.response) {
					if (action.filterKey === item[1]?.filterKey) {
						let filters = {...state[item[0]].filters};
						if (!filters.specific) {
							filters.specific = {page: 1};
						} else {
							filters.specific = {...filters.specific, page: 1};
						}

						result[item[0]] = {
							filters,
							response: {
								refresh: true
							}
						};
					}
				}
			});

			return {
				...result,
				filters,
				[action.parentName]: {
					...state[action.parentName],
					response: {refresh: true},
					filters: {...parentfilters, specific: {...parentfilters.specific, page: 1}}
				}
			};
		}

		case actions.CLEAR_PIC_EQR_DOCUMENT_LIST_FILTERS: {
			let _state = {...state};
			let filters = {..._state.filters};
			let parentfilters = {..._state[action.parentName]?.filters};
			let shared;

			// Delete all filter levels up to Url filters, that is Specific, Shared, and Url and Session
			if (parentfilters.specific) {
				parentfilters.specific = {
					...parentfilters.specific,
					orderBy: parentfilters.specific.orderBy,
					orderByAscending: parentfilters.specific.orderByAscending
				};
			}

			// If Url filters were defined, override them with undefined
			//shared = clearFilterLevel(filters, action, shared, 'queryString');
			shared = clearFilterLevel(parentfilters, action, shared, 'session');
			let staticFilters = {};
			if (!_.isUndefined(filters[action.filterKey]?.searchstring)){
				staticFilters = {...staticFilters, searchstring:filters[action.filterKey]?.searchstring}
			}
			if (!_.isUndefined(filters[action.filterKey]?.searchtype)){
				staticFilters = {...staticFilters, searchtype:filters[action.filterKey]?.searchtype}
			}

			return {
				...state,

				// Shared delete is beign done here
				filters: {...shared,[action.filterKey]:{...staticFilters}},

				[action.parentName]: {
					filters: parentfilters,
					response: {
						refresh: true
					},
					upload: state[action.parentName]?.upload
				}
			};
		}

		case actions.UPDATE_PIC_EQR_PAGINATION_STATE: {
			let filters = {...state[action.parentName]?.filters};
			return {
				...state,

				[action.parentName]: {
					...state[action.parentName],
					filters: {...filters, specific: {...filters.specific, ...action.specificObj}}
				}
			};
		}

		case 'API_ERROR':
			return {
				...state,
				errors: {
					api_error: action.error
				}
			};
		default:
			return state;
	}
}

function clearFilterLevel(filters, action, shared, level) {
	if (filters[level]) {
		Object.keys(filters[level]).forEach((filter) => {
			if (action.filterState && action.filterState[filter]?.appliesTo?.some((item) => item === action.parentName)) {
				if (!filters.specific) {
					filters.specific = {};
				}

				filters.specific[filter] = null;
			} else {
				if (!shared) {
					shared = {
						[action.filterKey]: {}
					};
				}

				if ((shared[action.filterKey] && shared[action.filterKey][filter]) || filters.queryString[filter]) {
					shared[action.filterKey][filter] = null;
				}
			}
		});
	}
	return shared;
}
